import { combineReducers } from 'redux';

import { profileInfo } from './redux/reducers/profile/profile';
import { performers } from './redux/reducers/performers/performers';
import { signatures } from './redux/reducers/signatures/signatures';
import { filters } from './redux/reducers/filters/filters';
import { licensee } from './redux/reducers/licensee/licensee';

export const SystemSettings = combineReducers({
  profileInfo,
  performers,
  signatures,
  filters,
  licensee
});
